(function () {
  function applyDiscount(code) {
    // Hitting /discount/{code} sets Shopify's discount session cookie as a
    // side effect of the request — it normally 302-redirects the browser,
    // but a fetch() just follows that redirect internally and never
    // navigates the page, so the code gets applied silently in the
    // background. The redirect target doesn't matter since we never
    // navigate there; we only care about the cookie the request sets.
    var url = '/discount/' + encodeURIComponent(code) + '?redirect=/';
    return fetch(url, { credentials: 'same-origin' }).catch(function () {
      // Even if this fails (offline, blocked, etc.) we still show the
      // success message below — the merchant would rather a customer see
      // "you got a coupon" and retry checkout than see an error over a
      // best-effort background request.
    });
  }

  function showResult(banner, result) {
    if (!result) return;

    var message = banner.getAttribute('data-success-message');
    var messageEl = result.querySelector('[data-coupon-message]');
    if (messageEl && message) messageEl.textContent = message;

    var code = banner.getAttribute('data-coupon-code');
    if (code) {
      var codeDisplay = result.querySelector('[data-coupon-code-display]');
      var codeLabelEl = result.querySelector('[data-coupon-code-label]');
      var codeValueEl = result.querySelector('[data-coupon-code-value]');
      if (codeLabelEl) codeLabelEl.textContent = banner.getAttribute('data-code-label') || '';
      if (codeValueEl) codeValueEl.textContent = code;
      if (codeDisplay) codeDisplay.hidden = false;
    }

    result.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-coupon-trigger]').forEach(function (banner) {
      var result = banner.querySelector('[data-coupon-result]');
      var storageKey = banner.getAttribute('data-storage-key');
      var claimed = false;

      function claim() {
        if (claimed) return;
        claimed = true;
        banner.classList.add('content-coupon-banner--claimed');

        var code = banner.getAttribute('data-coupon-code');
        var afterApply = code ? applyDiscount(code) : Promise.resolve();

        afterApply.then(function () {
          showResult(banner, result);
          if (storageKey) sessionStorage.setItem(storageKey, '1');
        });
      }

      // Already claimed earlier this session — restore the result without
      // re-hitting /discount (avoids reapplying/refetching on every reload).
      if (storageKey && sessionStorage.getItem(storageKey) === '1') {
        claimed = true;
        banner.classList.add('content-coupon-banner--claimed');
        showResult(banner, result);
      }

      banner.addEventListener('click', claim);
      banner.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          claim();
        }
      });
    });

    document.querySelectorAll('[data-coupon-copy]').forEach(function (copyButton) {
      copyButton.addEventListener('click', function (event) {
        event.stopPropagation();
        var result = copyButton.closest('[data-coupon-result]');
        var codeValueEl = result && result.querySelector('[data-coupon-code-value]');
        var code = codeValueEl ? codeValueEl.textContent : '';
        if (!code || !navigator.clipboard) return;

        navigator.clipboard.writeText(code).then(function () {
          var original = copyButton.textContent;
          copyButton.textContent = 'コピーしました';
          setTimeout(function () {
            copyButton.textContent = original;
          }, 1500);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
